var $0f9b1074d04f4954$exports = {};
$0f9b1074d04f4954$exports = {
  "alpha": "\u0410\u043B\u044C\u0444\u0430",
  "black": "\u0447\u043E\u0440\u043D\u0438\u0439",
  "blue": "\u0421\u0438\u043D\u0456\u0439",
  "blue purple": "\u0441\u0438\u043D\u044C\u043E-\u0444\u0456\u043E\u043B\u0435\u0442\u043E\u0432\u0438\u0439",
  "brightness": "\u042F\u0441\u043A\u0440\u0430\u0432\u0456\u0441\u0442\u044C",
  "brown": "\u043A\u043E\u0440\u0438\u0447\u043D\u0435\u0432\u0438\u0439",
  "brown yellow": "\u043A\u043E\u0440\u0438\u0447\u043D\u0435\u0432\u043E-\u0436\u043E\u0432\u0442\u0438\u0439",
  "colorName": function colorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue);
  },
  "cyan": "\u0431\u043B\u0430\u043A\u0438\u0442\u043D\u0438\u0439",
  "cyan blue": "\u0441\u0438\u043D\u044C\u043E-\u0431\u043B\u0430\u043A\u0438\u0442\u043D\u0438\u0439",
  "dark": "\u0442\u0435\u043C\u043D\u0438\u0439",
  "gray": "\u0441\u0456\u0440\u0438\u0439",
  "grayish": "\u0441\u0456\u0440\u0443\u0432\u0430\u0442\u0438\u0439",
  "green": "\u0417\u0435\u043B\u0435\u043D\u0438\u0439",
  "green cyan": "\u0437\u0435\u043B\u0435\u043D\u043E-\u0431\u043B\u0430\u043A\u0438\u0442\u043D\u0438\u0439",
  "hue": "\u0422\u043E\u043D",
  "light": "\u0441\u0432\u0456\u0442\u043B\u0438\u0439",
  "lightness": "\u041E\u0441\u0432\u0456\u0442\u043B\u0435\u043D\u0456\u0441\u0442\u044C",
  "magenta": "\u043F\u0443\u0440\u043F\u0443\u0440\u043E\u0432\u0438\u0439",
  "magenta pink": "\u043F\u0443\u0440\u043F\u0443\u0440\u043E\u0432\u043E-\u0440\u043E\u0436\u0435\u0432\u0438\u0439",
  "orange": "\u043F\u043E\u043C\u0430\u0440\u0430\u043D\u0447\u0435\u0432\u0438\u0439",
  "orange yellow": "\u043F\u043E\u043C\u0430\u0440\u0430\u043D\u0447\u0435\u0432\u043E-\u0436\u043E\u0432\u0442\u0438\u0439",
  "pale": "\u0431\u043B\u0456\u0434\u0438\u0439",
  "pink": "\u0440\u043E\u0436\u0435\u0432\u0438\u0439",
  "pink red": "\u0440\u043E\u0436\u0435\u0432\u043E-\u0447\u0435\u0440\u0432\u043E\u043D\u0438\u0439",
  "purple": "\u0444\u0456\u043E\u043B\u0435\u0442\u043E\u0432\u0438\u0439",
  "purple magenta": "\u0444\u0456\u043E\u043B\u0435\u0442\u043E\u0432\u043E-\u043F\u0443\u0440\u043F\u0443\u0440\u043E\u0432\u0438\u0439",
  "red": "\u0427\u0435\u0440\u0432\u043E\u043D\u0438\u0439",
  "red orange": "\u0447\u0435\u0440\u0432\u043E\u043D\u043E-\u043F\u043E\u043C\u0430\u0440\u0430\u043D\u0447\u0435\u0432\u0438\u0439",
  "saturation": "\u041D\u0430\u0441\u0438\u0447\u0435\u043D\u0456\u0441\u0442\u044C",
  "transparentColorName": function transparentColorName(args) {
    return "".concat(args.lightness, " ").concat(args.chroma, " ").concat(args.hue, ", \u043F\u0440\u043E\u0437\u043E\u0440\u0438\u0439 \u043D\u0430 ").concat(args.percentTransparent);
  },
  "very dark": "\u0434\u0443\u0436\u0435 \u0442\u0435\u043C\u043D\u0438\u0439",
  "very light": "\u0434\u0443\u0436\u0435 \u0441\u0432\u0456\u0442\u043B\u0438\u0439",
  "vibrant": "\u044F\u0441\u043A\u0440\u0430\u0432\u0438\u0439",
  "white": "\u0431\u0456\u043B\u0438\u0439",
  "yellow": "\u0436\u043E\u0432\u0442\u0438\u0439",
  "yellow green": "\u0436\u043E\u0432\u0442\u043E-\u0437\u0435\u043B\u0435\u043D\u0438\u0439"
};
export { $0f9b1074d04f4954$exports as default };